const storageUrl = process.env.REACT_APP_STORAGE_URL;

export const urlHeader = `https://firebasestorage.googleapis.com/v0/b/${storageUrl}.appspot.com/o/`;
export const urlFooter = ".mp3?alt=media";

export const LOCAL_STORAGE_THUMBNAIL_KEY = "totalArtistThumbnailList";

export const Colors = {
  WHITE: "white",
  ACCENT1: "#ffc700",
  BLACK: "#000000",
  LIGHT_BLACK: "#0f0f0f",
  GRAY: "#373737",
  LIGHT_GRAY: "#BBB9B9",
  DARK_GRAY: "#1E1D1D",
  text_grey: "#BBB9B9",
  Homebrew_darkgrey2: "#333333",
  RED: "red",
};
